import { HomeSection } from '../../../common/HomeSection.jsx'
import { Icons } from '../../../common/Icons.jsx'
import { MAIN_REJESTR_API_LONG } from '../../../utils/consts.js'
import HasRole from "../../../common/authirization/HasRole.jsx";
import {AIChatModalContent} from "../../../common/index.js";
import {useState} from "react";
import {useSelector} from "react-redux";

const ViewOperHome = () => {
    const [showAIChat, setShowAIChat] = useState(false)

    return (
        <>
            <HomeSection
                title={'Realizacja'}
                items={[
                    {
                        icon: <Icons.task size={80} />,
                        title: 'Projekty',
                        perms: ['rejestr_podglad'],
                        text: 'Przejdź do listy projektów - przeglądaj, dodawaj, modyfikuj i usuwaj projekty',
                        actionLink: `/oper/${MAIN_REJESTR_API_LONG}/lista`,
                        actionText: 'Przejdź do projektów',
                    },
                    {
                        icon: <Icons.addToGroup size={80} />,
                        title: 'Profile',
                        perms: ['profile_podglad'],
                        text: 'Przejdź do listy profili',
                        actionLink: `/oper/profile/lista`,
                        actionText: 'Przejdź do profilów',
                    },
                ]}
            />
            <HomeSection
                title={'Narzędzia'}
                items={[
                    {
                        icon: <Icons.translate size={80} />,
                        title: 'Słowniki',
                        perms: ['slowniki_podglad'],
                        text: 'Przejdź do managera słowników - dodawaj, modyfikuj i usuwaj słowniki dostępne w aplikacji',
                        actionLink: '/oper/slowniki/lista',
                        actionText: 'Przejdź do słowników',
                    },
                    {
                        icon: <Icons.config size={80} />,
                        title: 'Konfiguracja',
                        perms: ['konfiguracja_modyfikacja'],
                        text: 'Konfiguracja aplikacji',
                        actionLink: '/oper/konfiguracja/lista',
                        actionText: 'Przejdź do konfiguracji',
                    },
                    {
                        icon: <Icons.excel size={80} />,
                        title: 'Raporty',
                        perms: ['raporty_podglad'],
                        text: 'Lista raportów',
                        actionLink: '/oper/raporty',
                        actionText: 'Przejdź do raportów',
                    },
                    {
                        icon: <Icons.aiDb size={80}/>,
                        title: 'Czat z bazą',
                        perms:['ai_raporty_podglad'],
                        text: 'Rozmawiaj z bazą danych',
                        onClick: () => setShowAIChat(true),
                    },
                    {
                        icon: <Icons.user size={80} />,
                        title: 'Moje dane',
                        text: 'Dane użytkownika',
                        actionLink: '/uzytkownik/moje-dane',
                        actionText: 'Przejdź do swoich danych',
                    },
                ]}
            />
            {showAIChat &&
                <HasRole roles={['ai_raporty_podglad']} mode={'all'}>
                    <AIChatModalContent
                        show={showAIChat}
                        handleClose={() => setShowAIChat(false)}
                    />
                </HasRole>
            }
        </>
    )
}

export default ViewOperHome
